import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Icon, LinkBtn } from '@manychat/manyui'

import cm from './SettingsModalButton.module.css'

export default class SettingsModalButton extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
  }

  render() {
    const { onClick, className, style } = this.props
    return (
      <div style={style} className={cx('m-l p-l-xs', cm.wrap, className)}>
        <LinkBtn onClick={onClick} className={cm.icon}>
          <Icon.Settings size={32} />
        </LinkBtn>
      </div>
    )
  }
}
